import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { BroadcastFilter } from '../../models/BroadcastFilter';
import { IntegrationSummary } from '../../models/IntegrationSource';
import { AuthService } from '../../shared/services/auth.service';
import { IntegrationBroadcastsService } from '../../shared/services/integration-broadcasts.service';
import { formatDateParam, isInvalidPeriod } from './date-param';

/**
 * "SMS via Integração", level 1 — ONE ROW PER INTEGRATION.
 *
 * The underlying rows are one-SMS-per-contact (an ActiveCampaign automation calls
 * the API once per contact), so listing them raw means thousands of lines. This
 * screen collapses them into the unit the operator thinks in: the integration,
 * with its automation count, totals and last activity.
 *
 * Drill-down is /integration-sms/view/:source.
 */
@Component({
  selector: 'app-integration-sms',
  templateUrl: './integration-sms.component.html',
  styleUrls: ['./integration-sms.component.scss']
})
export class IntegrationSmsComponent implements OnInit, OnDestroy {
  startedMonth: Date;
  endedMonth: Date;

  loading: boolean;
  integrations: IntegrationSummary[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    private integrationBroadcastsService: IntegrationBroadcastsService,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.list();

    // O admin troca de conta simulada sem sair da tela: sem isso a lista
    // continuaria mostrando os envios do cliente anterior.
    this.subscriptions.push(
      this.authService.userChanged.subscribe(() => this.list())
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  get invalidPeriod(): boolean {
    return isInvalidPeriod(this.startedMonth, this.endedMonth);
  }

  list(): void {
    // Guarda além do `[disabled]` do botão: o form também é submetido pelo Enter
    // dentro de um campo, que não passa pelo botão.
    if (this.invalidPeriod) {
      return;
    }

    const filter: BroadcastFilter = {
      startDate: formatDateParam(this.startedMonth),
      endDate: formatDateParam(this.endedMonth),
      text: null,
      order: null,
      orderDirection: null,
      author: null
    };

    this.loading = true;

    this.subscriptions.push(
      this.integrationBroadcastsService.listIntegrations(filter)
        .pipe(finalize(() => this.loading = false))
        .subscribe(integrations => this.integrations = integrations)
    );
  }

  open(integration: IntegrationSummary): void {
    this.router.navigate(['/integration-sms/view', integration.id]);
  }
}
